import { getSharingTipInfo } from './getSharingTipInfo';
import { IdType, SharingData } from '../schema/SharingData';
import { SharingTipInfo } from '../types/SharingTipInfo';
import { SharingTipId } from '../types/sharingTipId';
import { SharingTipRecipientInfo } from '../types/SharingTipRecipientInfo';
import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';
import {
    InfoBarCustomAction,
    InfoBarMessageSource,
    InfoBarMessageViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

// TODO VSO 32530: Deciding if the infobar has custom actions, and what they are, should be done here. Passing in the downsell action is merely a bandaid
// to maintain existing functionality while I (kcurlett) rewrite sharing tips/infobar actions to be satchelV3 actions.
export function getInfoBarCreator(
    sharingData: SharingData[],
    sharingTipId: SharingTipId,
    recipientInfo: SharingTipRecipientInfo[],
    skipActionRecommendation: boolean,
    convertCloudyToClassicAction?: (id: IdType) => InfoBarCustomAction
): InfoBarMessageViewStateCreator | null {
    const sharingTipInfo: SharingTipInfo | null = getSharingTipInfo(
        sharingData,
        sharingTipId,
        recipientInfo,
        skipActionRecommendation,
        convertCloudyToClassicAction
    );

    if (sharingTipInfo === null) {
        return null;
    }

    const infoBarMessageViewState: InfoBarMessageViewState = {
        key: sharingTipId,
        source: InfoBarMessageSource.Compose,
        rank: sharingTipInfo.messageRank,
        messageParts: [sharingTipInfo.sharingTipString],
    };

    if (sharingTipInfo.actions !== null) {
        sharingTipInfo.actions.map(action => {
            infoBarMessageViewState.messageParts.push(action);
        });
    }

    // viewState in this case will be a ComposeViewState. We can't use that type though since it will create a circular dependency.
    return (viewState: any /*ComposeViewState */) => infoBarMessageViewState;
}
